<template>
    <!-- modal-xl -->
    <b-modal id="addTeamMemberModal" title="Add Team Member" title-class="font-18" hide-footer>
        <b-overlay :show="show">
            <div class="textcenter">
                <!-- <h5 class="mb-3">{{ this.searchForm.company_name }}</h5> -->
                <b-form>
                    <b-form-group label="Name:" label-cols-sm="3" label-size="sm" class="align-text-setting mr-5">
                        <b-form-input
                            v-model="$v.createUserForm.first_name.$model"
                            size="sm"
                            :state="validateState('first_name')"
                            aria-describedby="input-1-live-feedback"
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2">
                            Required, also needs to be atleast 4 characters long
                        </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group label="Surname" label-cols-sm="3" label-size="sm" class="align-text-setting mr-5">
                        <b-form-input
                            v-model="$v.createUserForm.last_name.$model"
                            size="sm"
                            :state="validateState('last_name')"
                            aria-describedby="input-1-live-feedback"
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2">
                            Required, also needs to be atleast 4 characters long
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group label="Email:" label-cols-sm="3" label-size="sm" class="align-text-setting mr-5">
                        <b-form-input
                            v-model="$v.createUserForm.email.$model"
                            size="sm"
                            type="email"
                            :state="validateState('email')"
                            aria-describedby="input-2-live-feedback"
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2">
                            Required
                        </b-form-invalid-feedback>
                        <!-- <b-form-invalid-feedback id="input-2-live-feedback" class="text-left ml-2">
                        Either Reg No or Vat No must be filled in. Reg No must be atleast 3 Characters long
                    </b-form-invalid-feedback> -->
                    </b-form-group>

                    <b-form-group label="Password:" label-cols-sm="3" label-size="sm" class="align-text-setting mr-5">
                        <b-form-input
                            v-model="$v.createUserForm.password.$model"
                            size="sm"
                            type="password"
                            :state="validateState('password')"
                            aria-describedby="input-2-live-feedback"
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2">
                            Required, also needs to be atleast 8 characters long
                        </b-form-invalid-feedback>
                        <!-- <b-form-invalid-feedback id="input-2-live-feedback" class="text-left ml-2">
                        Either Reg No or Vat No must be filled in. Reg No must be atleast 3 Characters long
                    </b-form-invalid-feedback> -->
                    </b-form-group>
                </b-form>
            </div>

            <div class="modal-footer d-flex justify-content-end">
                <b-button variant="primary" type="button" class="btn btn-primary" @click="addUser">
                    Add User
                </b-button>
                <b-button variant="primary" type="button" class="btn btn-primary" @click="closeModal">
                    Cancel
                </b-button>
            </div>
        </b-overlay>
    </b-modal>
</template>

<script>
//eslint-disable-next-line
import Swal from "sweetalert2";
import { adminComputed, adminMethods, userAdministrationComputed, userAdministrationMethods } from "../../../state/helpers";
//eslint-disable-next-line
import { required, minLength, maxLength, numeric, date, email } from "vuelidate/lib/validators";

export default {
    data: () => ({
        show: false,
        formSubmit: false,
        //values for the calendar
        createUserForm: {
            first_name: "",
            last_name: "",
            email: "",
            password: "",
        },
    }),
    validations: {
        createUserForm: {
            first_name: {
                required,
                minLength: minLength(4),
            },
            last_name: {
                required,
                minLength: minLength(4),
            },
            email: {
                required,
                email,
                minLength: minLength(4),
            },
            password: {
                required,
                minLength: minLength(8),
            },
        },
    },
    computed: {
        ...adminComputed,
        ...userAdministrationComputed,
    },
    methods: {
        ...adminMethods,
        ...userAdministrationMethods,
        validateState(name) {
            if (this.formSubmit) {
                const { $dirty, $error } = this.$v.createUserForm[name];
                return $dirty ? !$error : null;
            }
        },

        closeModal() {
            this.$bvModal.hide("addTeamMemberModal");
        },

        addUser() {
            //eslint-disable-next-line
            console.log(this.createUserForm);
            this.formSubmit = true;

            this.$v.createUserForm.$touch();
            if (this.$v.createUserForm.$anyError) {
                return;
            }
            this.show = true;

            //eslint-disable-next-line
            console.log("validation passede");

            Swal.fire({
                title: ` Add Team Member `,
                text: `Add ${this.createUserForm.first_name}?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Confirm",
            }).then((result) => {
                if (result.value) {
                    this.saveAddTeamMember(this.createUserForm).then(() => {
                        Swal.fire(`Team Member Updated`, "", "success");

                        //refresh
                        // this.setSupplierCertificates(this.selected_supplier_details.id);
                        this.setUsersForPermissions();

                        this.closeModal();

                        this.show = false;
                    });
                }
                this.show = false;
            });
        },
    },
    mounted() {
        //eslint-disable-next-line
        console.log("add team member mdoal");
    },
};
</script>

<style lang="scss" scoped>
.align-text-setting {
    text-align: right;
}
@media only screen and (max-width: 990px) {
    .align-text-setting {
        text-align: left;
    }
}
</style>
